import * as React from "react";
import {useContext, useEffect} from "react";
import { AppCommandPromptContext, IAppCommandPromptRegistration } from "./appcommandpromptcontext";
export type { IAppCommandPromptRegistration } from "./appcommandpromptcontext";

export interface IAppCommandPromptRegistrationProps {
    children?: React.ReactNode;   
    registration: IAppCommandPromptRegistration;
}


export function AppCommandPromptRegistration(props: IAppCommandPromptRegistrationProps) {
    const context = useContext(AppCommandPromptContext);
    
    useEffect(() => {
        if (props.registration) {
            context.registerCommands(props.registration);
            return () => {
                context.unregisterCommands(props.registration);
            }
        }
    }, [props.registration]);

    return <>{props.children}</>;
}